import {
  DetailsHeader,
  DetailsList,
  DetailsRow,
  Selection,
  SelectionMode,
} from 'office-ui-fabric-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SORTING_KEYS } from '../../../../constants/sortingKeys';
import { filterAndSortingKeys } from '../../../../utilities/filterAndSortingsUtil';

const listStyle = {
  root: {
    backgroundColor: '#FAFAFA',
  },
};

export const HearingTypeList = ({
  hearingTypeItems,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  onHearingTypeClick,
  onHearingTypeSelect,
}) => {
  const { t: translator } = useTranslation();

  const onHearingTypeClickCallback = (hearingTypeItem) => {
    onHearingTypeClick && onHearingTypeClick(hearingTypeItem.key);
  };

  const onSelectionChanged = () => {
    const [selection] = listSelection.getSelection();
    onHearingTypeSelect && onHearingTypeSelect(selection && selection.key);
  };

  const [listSelection] = useState(
    new Selection({
      onSelectionChanged: onSelectionChanged,
      selectionMode: SelectionMode.single,
    }),
  );

  const selectionKey =
    hearingTypeItems && hearingTypeItems.length
      ? hearingTypeItems
          .map((i) => i.key)
          .sort()
          .join('')
      : 'none';

  const sortingKey = filterAndSortingSelection[filterAndSortingKeys.sortingKey];

  return (
    <div className="changeHearingOwner-list">
      {
        <DetailsList
          items={hearingTypeItems}
          setKey={selectionKey}
          selection={listSelection}
          ariaLabel={translator('ariaLabel.hearingTypeListLabel')}
          ariaLabelForSelectAllCheckbox={translator('ariaLabel.listSelectAll')}
          ariaLabelForSelectionColumn={translator(
            'ariaLabel.listSelectionColumn',
          )}
          isCompactMode={false}
          columns={columns(sortingKey, translator)}
          onColumnHeaderClick={onColumnHeaderClick(
            sortingKey,
            filterAndSortingSelection,
            setFilterAndSortingSelection,
          )}
          onRenderDetailsHeader={(props) => {
            return (
              <DetailsHeader
                {...props}
                styles={listStyle}
                ariaLabel={translator('ariaLabel.listHeader')}
              />
            );
          }}
          onRenderRow={(props) => {
            return <DetailsRow tabIndex="0" {...props} styles={listStyle} />;
          }}
          compact={false}
          onItemInvoked={onHearingTypeClickCallback}
        />
      }
    </div>
  );
};

const columns = (sortingKey, translator) => [
  {
    key: 'title',
    name: translator('hearingProperties.hearingType'),
    ariaLabel: translator('hearingProperties.hearingType'),
    fieldName: 'title',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 350,
    isSorted:
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL ||
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL_REVERSE,
    isSortedDescending: sortingKey === SORTING_KEYS.TITLEALPHABETICAL,
  },
  {
    key: 'status',
    name: translator('hearingProperties.hearingStatus'),
    ariaLabel: translator('hearingProperties.hearingStatus'),
    fieldName: 'status',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 110,
    isSorted:
      sortingKey === SORTING_KEYS.STATUS_ASC ||
      sortingKey === SORTING_KEYS.STATUS_DESC,
    isSortedDescending: sortingKey === SORTING_KEYS.STATUS_ASC,
  },
  {
    key: 'isInternal',
    name: translator('hearingProperties.internalHearing'),
    ariaLabel: translator('hearingProperties.internalHearing'),
    fieldName: 'isInternal',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 110,
    isSorted:
      sortingKey === SORTING_KEYS.ISINTERNAL_YES ||
      sortingKey === SORTING_KEYS.ISINTERNAL_NO,
    isSortedDescending: sortingKey === SORTING_KEYS.ISINTERNAL_NO,
  },
  {
    key: 'numberOfHearings',
    data: 'integer',
    name: translator('hearingProperties.numOfHearings'),
    ariaLabel: translator('hearingProperties.numOfHearings'),
    fieldName: 'numberOfHearings',
    isPadded: true,
    isResizable: false,
    minWidth: 140,
    isSorted:
      sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC ||
      sortingKey === SORTING_KEYS.NUMOFHEARINGS_DESC,
    isSortedDescending: sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC,
  },
];

const onColumnHeaderClick = (
  sortingKey,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
) => (_, col) => {
  let resultingSortingKey = null;

  if (col.key === 'title') {
    if (sortingKey === SORTING_KEYS.TITLEALPHABETICAL) {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL_REVERSE;
    } else {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL;
    }
  } else if (col.key === 'status') {
    if (sortingKey === SORTING_KEYS.STATUS_ASC) {
      resultingSortingKey = SORTING_KEYS.STATUS_DESC;
    } else {
      resultingSortingKey = SORTING_KEYS.STATUS_ASC;
    }
  } else if (col.key === 'isInternal') {
    if (sortingKey === SORTING_KEYS.ISINTERNAL_YES) {
      resultingSortingKey = SORTING_KEYS.ISINTERNAL_NO;
    } else {
      resultingSortingKey = SORTING_KEYS.ISINTERNAL_YES;
    }
  } else if (col.key === 'numberOfHearings') {
    if (sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC) {
      resultingSortingKey = SORTING_KEYS.NUMOFHEARINGS_DESC;
    } else {
      resultingSortingKey = SORTING_KEYS.NUMOFHEARINGS_ASC;
    }
  }

  if (resultingSortingKey) {
    let currFilterAndSortingSelection = Object.assign(
      {},
      filterAndSortingSelection,
    );
    currFilterAndSortingSelection[
      filterAndSortingKeys.sortingKey
    ] = resultingSortingKey;
    setFilterAndSortingSelection(currFilterAndSortingSelection);
  }
};
